import { connect } from "react-redux";
import PremierError from "../../components/PremierError/index.jsx";
import { fetchCountries } from "../../actions/PremierSelectorOptions";

const mapStateToProps = (state) => ({
  assetsUrl: state.Environment.assetsUrl,
  apiError: state.CountrySelector.apiError,
  errorMessage: state.PremierPageFrame.errorMessage,
  error: state.PremierSelectorOptions.error,
  payload: state.PremierSelectorOptions.payload,
  content: state.PremierPageFrame.content,
  contentError: state.PremierPageFrame.errorMessage,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCountries: (country, currency, storeId, language) => {
    dispatch(fetchCountries(country, currency, storeId, language));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PremierError);
